import { type FC } from 'react';
import RegisterLayout from '@/registration/component/Register/Layout';
import CategoryForm from './CategoryForm';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { useGroupAttendeeCategoryQuery } from '@/registration/hook/useGroupAttendeeCategoryQuery';
import { useKitchenSink } from '@/app/ProviderKitchenSink';
// import GroupHeader from '@/registration/component/Register/Layout/GroupHeader';

const Category: FC = () => {
  const { eventId } = useRegisterRoute();
  const attendeeCategoryQuery = useGroupAttendeeCategoryQuery(eventId);
  const { attendeeCategoryId } = useKitchenSink();

  return (
    <RegisterLayout showShoppingCart={false}>
      <CategoryForm
        attendeeCategoryData={attendeeCategoryQuery.data}
        attendeeCategoryId={Number(attendeeCategoryId)}
      />
    </RegisterLayout>
  );
};

export default Category;
